import type { ReactNode } from "react";
import { AnimatedHeight } from "./AnimatedHeight";
import { FadeInDown } from "./FadeInDown";

interface PreviewCardProps {
  children: ReactNode;
  animateOnMount?: boolean;
}

export const PreviewCard = ({ children, animateOnMount }: PreviewCardProps) => (
  <FadeInDown enabled={animateOnMount}>
    <AnimatedHeight>
      <div className="overflow-hidden rounded-3xl bg-white">{children}</div>
    </AnimatedHeight>
  </FadeInDown>
);
